
import { useState } from "react";

import { LayoutCrearDoc } from "../../layouts";
import { useUsuarioXID } from "../../../hooks/cache";
import { useAuthStore, useImagenStore } from "../../../stores";
import { FromPerfilUsuario } from "../../dashboard/components";
import { CargandoMedio } from "../../components";
import { startEditarUsuario } from "../../../services";

import Swal from "sweetalert2";






export const MiPerfil = () => {


    const { imagen } = useImagenStore();
    const { cliente, startEditarPerfilCliente } = useAuthStore();
    const { data, isLoading } = useUsuarioXID(cliente?.id);
    const [cargando, setCargando] = useState(false);

    
    const actualizarUsuario = async (e, formUsuario) => {
        e.preventDefault();

        const camposRequeridos = ['nombre', 'email', 'direccion', 'movil', 'profesion', 'cedula'];
        if (camposRequeridos.some(key => !formUsuario[key]?.trim())) {
            return Swal.fire('Error', 'Debes llenar todos los campos del formulario', 'error');
        }

        const { isConfirmed } = await Swal.fire({
            title: 'Editar  Perfil',
            text: `¿Está seguro de editar tu perfil?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sí, editar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            reverseButtons: true,
        });

        if(!isConfirmed) return;

        setCargando(true);
        const resp = await startEditarUsuario({ ...formUsuario, id:cliente.id, img:imagen });
        setCargando(false);
        if(resp) { startEditarPerfilCliente(resp) }
    };


    return (

        <LayoutCrearDoc titulo='Mi Perfil' add={false} pt={4} px={5}>
            {(isLoading)
            ?   <CargandoMedio titulo="Cargando información de mi perfil..." />
            :   <FromPerfilUsuario funcion={ actualizarUsuario } data={data} cargando={cargando} />
            }
        </LayoutCrearDoc>

    )
}
